import React from 'react';
import MediaQuery from 'react-responsive';
import CompletedProjectsMobile from 'components/organisms/completedProjectsMobile';
import CompletedProjects from 'components/organisms/completedProjects';

const CompletedProjectsSection = props => {
  return (
    <div id={'completed-projects'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <CompletedProjectsMobile data={props.data} />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <CompletedProjects data={props.data} />
      </MediaQuery>
    </div>
  );
};

export default CompletedProjectsSection;
